export default "__VITE_ASSET__BrxAv2cx__"